import { render, staticRenderFns } from "./HotelEdit.vue?vue&type=template&id=194d10fe"
import script from "./HotelEdit.vue?vue&type=script&lang=js"
export * from "./HotelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports